export default __webpack_public_path__ + "static/media/video-interview-secondary-icon.6fde2162.svg";